/* import __COLOCATED_TEMPLATE__ from './confirmation-modal-market.hbs'; */
import ConfirmationModal from '@dashboard/junk-drawer/components/modals/confirmation-modal';
export default class ConfirmationModalMarket extends ConfirmationModal {}